import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0134cb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-title-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "input_circle", -1))
const _hoisted_3 = { class: "row gx-5" }
const _hoisted_4 = { class: "col-4 col-xl-3 sidebar" }
const _hoisted_5 = { class: "col-8 col-xl-9 overview" }
const _hoisted_6 = { class: "row row-list gx-5" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: "col-4 col-xl-6 col-xxl-4"
}
const _hoisted_9 = { class: "row row-tiles" }
const _hoisted_10 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_OverviewCriteria = _resolveComponent("OverviewCriteria")!
  const _component_OverviewLegend = _resolveComponent("OverviewLegend")!
  const _component_OverviewControls = _resolveComponent("OverviewControls")!
  const _component_OverviewTable = _resolveComponent("OverviewTable")!
  const _component_OverviewCategorization = _resolveComponent("OverviewCategorization")!
  const _component_OverviewTiles = _resolveComponent("OverviewTiles")!
  const _component_base_container = _resolveComponent("base-container")!
  const _component_PimProductsDetail = _resolveComponent("PimProductsDetail")!
  const _component_BaseOffcanvas = _resolveComponent("BaseOffcanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_container, { "container-fluid": "" }, {
      default: _withCtx(() => [
        _createVNode(_component_BaseTitle, {
          title: _ctx.$t('pimProductOverview'),
          mb: 3,
          "show-refresh-button": "",
          onRefresh: _ctx.reloadContent
        }, _createSlots({ _: 2 }, [
          (_ctx.AbilityContext.isAuthorizedForFeature('PIM_DATA_MGMT'))
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_router_link, {
                      to: {name: 'pim-import-products'},
                      class: "btn btn-hover icon-link"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('import')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["title", "onRefresh"]),
        _createVNode(_component_AlertError2, {
          error: _ctx.productsOverviewUI.getError()
        }, null, 8, ["error"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_OverviewCriteria, {
              onReloadedContent: _ctx.onCriteriaInitialized,
              onSubmit: _ctx.reloadContent
            }, null, 8, ["onReloadedContent", "onSubmit"]),
            _createVNode(_component_OverviewLegend, { class: "mt-4" })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_OverviewControls, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  "has-category-expected-toggle": true,
                  class: "mb-3",
                  onChange: _ctx.onControlsChanged,
                  onDownloadCsv: _ctx.downloadOverviewAsCSV
                }, null, 8, ["products-overview", "has-products", "onChange", "onDownloadCsv"]),
                _createVNode(_component_OverviewTable, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  ui: _ctx.productsOverviewUI,
                  "is-category-expected": _ctx.productsPaging.isCategoriesExpected,
                  onDeletedProduct: _ctx.reloadContent,
                  onSelectedDpCat: _ctx.onSelectedDpCat,
                  onSelectedIntCat: _ctx.onSelectedIntCat,
                  onExceptions: _ctx.setExceptions,
                  onOpenOffCanvasProductDetail: _ctx.onOpenProductDetail
                }, null, 8, ["products-overview", "has-products", "ui", "is-category-expected", "onDeletedProduct", "onSelectedDpCat", "onSelectedIntCat", "onExceptions", "onOpenOffCanvasProductDetail"]),
                _createVNode(_component_OverviewControls, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  "has-category-expected-toggle": true,
                  class: "mt-3",
                  onChange: _ctx.onControlsChanged,
                  onDownloadCsv: _ctx.downloadOverviewAsCSV
                }, null, 8, ["products-overview", "has-products", "onChange", "onDownloadCsv"])
              ]),
              (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_CATEGORY'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.criteriaInitialized)
                      ? (_openBlock(), _createBlock(_component_OverviewCategorization, {
                          key: 0,
                          "products-overview": _ctx.productsOverview,
                          onSubmitted: _ctx.onCategorizationSubmitted
                        }, null, 8, ["products-overview", "onSubmitted"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.productsPaging.layout === _ctx.PimProductsOverviewPageLayoutEnum.LIST]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_OverviewControls, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  class: "mb-3",
                  onChange: _ctx.onControlsChanged,
                  onDownloadCsv: _ctx.downloadOverviewAsCSV
                }, null, 8, ["products-overview", "has-products", "onChange", "onDownloadCsv"]),
                _createVNode(_component_OverviewTiles, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  ui: _ctx.productsOverviewUI,
                  onOpenOffCanvasProductDetail: _ctx.onOpenProductDetail
                }, null, 8, ["products-overview", "has-products", "ui", "onOpenOffCanvasProductDetail"]),
                _createVNode(_component_OverviewControls, {
                  "products-overview": _ctx.productsOverview,
                  "has-products": _ctx.hasProducts,
                  class: "mt-3",
                  onChange: _ctx.onControlsChanged,
                  onDownloadCsv: _ctx.downloadOverviewAsCSV
                }, null, 8, ["products-overview", "has-products", "onChange", "onDownloadCsv"])
              ])
            ], 512), [
              [_vShow, _ctx.productsPaging.layout === _ctx.PimProductsOverviewPageLayoutEnum.TILES]
            ])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.AbilityContext.isAuthorizedForFeature('PIM_PRODUCT_INFO'))
      ? (_openBlock(), _createBlock(_component_BaseOffcanvas, {
          key: 0,
          id: _ctx.offcanvasProductDetailId,
          title: "PIM product",
          label: "PIM product",
          class: "offcanvas-wide",
          "custom-content": ""
        }, {
          default: _withCtx(() => [
            (_ctx.selectedDetailProduct?.product_info?.cnk_code)
              ? (_openBlock(), _createBlock(_component_PimProductsDetail, {
                  key: 0,
                  "cnk-code": _ctx.selectedDetailProduct.product_info.cnk_code
                }, null, 8, ["cnk-code"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["id"]))
      : _createCommentVNode("", true)
  ], 64))
}